import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";
import central from "../../assets/pdf/3PL Central.pdf";
import club from "../../assets/pdf/24+Fit+Club.pdf";
import campaign from "../../assets/pdf/Active_Campaign.pdf";
import advologix from "../../assets/pdf/Advologix.pdf";
import concert from "../../assets/pdf/Concert_health.pdf";
import solution from "../../assets/pdf/At Home Solutions.pdf";
import london_blog1 from "../../assets/images/country/london_blog1.webp";
import london_blog2 from "../../assets/images/country/london_blog2.webp";
import london_blog3 from "../../assets/images/country/london_blog3.webp";


const London = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
  <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
  <meta name="format-detection" content="telephone=no" />
  <title>Salesforce Consultant in London | Implementation, Integration & CRM Experts – Codezix </title>
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  <meta
    name="description"
    content="Looking for expert Salesforce consultants in London? Codezix provides end-to-end Salesforce implementation, consulting, and customization services to streamline workflows and boost business performance."
  />
  <meta
    name="keywords"
    content="Salesforce consulting london, Salesforce implementation london, Codezix Salesforce services, CRM solutions london, Salesforce experts london, Salesforce partner london, Custom Salesforce solutions"
  />

  {/* 1) Organization + WebSite + WebPage + Breadcrumb */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://codezix.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Salesforce Development Company in London",
          "item": "https://www.codezix.com/salesforce/development-company-in-london"
        }
      ]
    },
    {
      "@type": "Organization",
      "@id": "https://codezix.com/#organization",
      "url": "https://codezix.com",
      "name": "Codezix",
      "legalName": "Codezix Solutions",
      "logo": {
        "@type": "ImageObject",
        "url": "https://codezix.com/assets/images/logo.webp",
        "width": 250,
        "height": 80
      },
      "image": "https://codezix.com/assets/images/logo.webp",
      "description": "Codezix is a global Salesforce consulting and cloud solution provider, helping enterprises accelerate digital transformation.",
      "email": "info@codezix.com",
      "telephone": "+1-917-730-7436",
      "sameAs": [
        "https://www.linkedin.com/company/codezix",
        "https://www.facebook.com/codezix",
        "https://twitter.com/codezix"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://codezix.com/#website",
      "url": "https://codezix.com",
      "name": "Codezix",
      "publisher": { "@id": "https://codezix.com/#organization" }
    },
    {
      "@type": "WebPage",
      "@id": "https://www.codezix.com/salesforce/development-company-in-london#webpage",
      "url": "https://www.codezix.com/salesforce/development-company-in-london",
      "inLanguage": "en-US",
      "name": "Salesforce Consultant in London | Implementation, Integration & CRM Experts – Codezix",
      "isPartOf": { "@id": "https://codezix.com/#website" },
      "description": "Salesforce consulting, implementation, customization & integration services in London."
    }
  ]
}
    `}
  </script>

  {/* 2) Service schema */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/development-company-in-london#service",
  "name": "Salesforce Consulting & Implementation Services in London",
  "serviceType": "Salesforce Consulting, Implementation & Integration",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization",
    "name": "Codezix"
  },
  "description": "End-to-end Salesforce consulting, implementation, customization, and integration services in London by Codezix.",
  "url": "https://www.codezix.com/salesforce/development-company-in-london",
  "areaServed": { "@type": "City", "name": "London" }
}
    `}
  </script>

  {/* 3) FAQPage schema */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What Salesforce consulting services does Codezix offer in London?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Codezix handles CRM implementation, customization, integration, data migration, and ongoing support for London businesses."
      }
    },
    {
      "@type": "Question",
      "name": "How can I hire a Salesforce consultant from Codezix in London?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Contact us through the website or email, and we will create a tailored Salesforce consulting plan based on your needs."
      }
    },
    {
      "@type": "Question",
      "name": "Does Codezix provide Salesforce cloud solutions in London?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes — we support Sales Cloud, Service Cloud, Marketing Cloud, and build custom Salesforce apps for London businesses."
      }
    },
    {
      "@type": "Question",
      "name": "How experienced is Codezix in Salesforce projects in London?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Codezix has 30+ certified Salesforce experts and has completed 50+ CRM projects, including multiple implementations in London."
      }
    },
    {
      "@type": "Question",
      "name": "Can Codezix integrate Salesforce with other business applications in London?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes — we integrate Salesforce with ERP, eCommerce, analytics and internal business systems for seamless data flow."
      }
    },
    {
      "@type": "Question",
      "name": "Does Codezix offer Salesforce automation and AI solutions in London?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes — we deliver automation and AI solutions to help London businesses improve efficiency and customer experience."
      }
    },
    {
      "@type": "Question",
      "name": "How long does Salesforce implementation take in London?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Basic implementations take a few weeks; complex multi-cloud Salesforce projects may take several months."
      }
    },
    {
      "@type": "Question",
      "name": "Why choose Codezix for Salesforce consulting in London?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We provide certified Salesforce expertise, proven delivery success, and customized CRM solutions fit for London businesses."
      }
    }
  ]
}
    `}
  </script>

</Helmet>



            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In London</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/london.webp')} alt="Salesforce consulting london" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className='explore-heading text-left'>
                                <h2> Salesforce Consultant in London – Trusted Partner for Your CRM Success</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">Salesforce moves fast—just like London’s business scene. And if you want to stay ahead, your CRM better keep up. Salesforce can do a lot, but making it work for your business isn’t always straightforward. That’s where Codezix steps in.</p>
                            <p className="prose-lg wow fadeUp">We’re not your typical Salesforce consultant. We put people first and get hands-on with your business. No off-the-shelf fixes here. We build a CRM that fits your team, your processes, and the way you actually work. Our job is to cut out the clutter, make life easier for your team, and help you deliver a better experience for your customers. Whether you’re brand new to Salesforce or wrestling with a complicated setup, we’re right there with you.</p>
                            <p className="prose-lg wow fadeUp">Our certified team doesn’t just show up, lecture, and leave. We roll up our sleeves and get to know what you need now—and where you want to go next. Sales Cloud, Service Cloud, Marketing Cloud, custom apps—whatever your goals, we make Salesforce work for you, not the other way around.</p>
                            <p className="prose-lg wow fadeUp">The best thing? We treat you like a partner, not just another client. We stick around for the long haul with support, improvements, and real training, so your team grows more confident using Salesforce every day. Your CRM should help your business grow, not hold it back.</p>
                            <p className="prose-lg wow fadeUp">We’ve helped companies across finance, retail, healthcare, tech—you name it. That means we bring practical ideas to the table, not just theory. If you want a Salesforce consultant in London who actually cares about your results, you’ll feel at home with Codezix.</p>
                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Salesforce Consulting in London That Puts Your Business First</h2>
                                <p className="prose-lg">
                                    People expect more from businesses these days, and your CRM has to keep up. Salesforce is powerful, but it’s easy to get lost in endless features and settings. If you want real results, you need more than just the basics—you need a partner who actually gets what makes your business tick.
                                </p>
                                <p className="prose-lg">At Codezix, we help companies in London get the most out of Salesforce. We don’t believe in clunky systems or extra bells and whistles you’ll never use. Our focus is simple: build CRM solutions that solve real problems, make life easier for your team, and help you serve customers better. Nothing more, nothing less.</p>
                                <p className="prose-lg">We start by getting to know you and how your business works. We dig into your workflows, your sticking points, what your team does every day, and what your customers expect. Once we really understand your world, we build Salesforce around it—sometimes that means automation, sometimes custom integrations or advanced reporting, sometimes an entire overhaul.</p>
                                <p className="prose-lg">We handle everything: setup, custom development, data migration, integrations, dashboards, and ongoing support. Whether you use Sales Cloud, Service Cloud, Marketing Cloud, or something else, we make sure Salesforce becomes a real asset for your business.</p>
                                <p className="prose-lg">What sets us apart? We don’t just walk away after launch. We stick around, help you get the most from your system, and fine-tune things as your needs change. Our goal is to make Salesforce one of the strongest tools you have—today and for the long haul.</p>
                                <p className="prose-lg"> </p>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting London</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our Salesforce consulting experts in London work with you to identify CRM challenges, streamline workflows, and design strategies that improve efficiency and data accuracy.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation London</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Transform your business operations with Salesforce implementation tailored to your goals. Our certified professionals handle everything—from setup and configuration to data migration and training—ensuring a smooth and successful rollout.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='CRM solutions london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Every business is unique—your CRM should be too. Our team customizes Salesforce to match your processes, automating sales, marketing, and service functions for better results.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='Salesforce experts london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                From concept to deployment, our Salesforce app development services in London bring your ideas to life. Using Lightning, Apex, and LWC, we build scalable applications that enhance CRM functionality and user experience.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce partner london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We integrate Salesforce with ERP, CMS, DMS, and accounting systems for seamless data flow and enhanced cross-departmental collaboration—improving decision-making and operational transparency.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our experts ensure secure and accurate migration from legacy systems to Salesforce. We maintain data integrity, reduce downtime, and guarantee a smooth transition with minimal disruption.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Salesforce consulting london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support & Maintenance</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Enjoy peace of mind with 24/7 Salesforce support and maintenance services. We proactively monitor, troubleshoot, and optimize your system to ensure peak performance at all times.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Your go-to Salesforce partner in London</h2>
                                <p className="prose-lg">For us, being your Salesforce partner isn’t just about ticking off tasks or rolling out new software. We get to know your business, back up your team, and stick with you for the long haul.</p>
                                <p className="prose-lg">Our certified consultants build solutions that actually make sense for your people. We cut down on busywork so your team can zero in on what really matters. Starting from scratch or tweaking what you’ve already got? We make Salesforce work for you—so it’s a tool your team wants to use, not one they dread.</p>
                            </div>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation london' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='CRM solutions london' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce experts london' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce partner london' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce consulting london' />
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Expertise Across All Clouds</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    Our London-based Salesforce consultants know the entire Salesforce ecosystem inside out. Sales Cloud, Service Cloud, Marketing, Commerce—you name it, we handle it. We don’t just set things up; we shape Salesforce to fit your business, your industry, and where you want to go next.</p>
                                <p className="wow fadeUp prose-lg text-left">If you’re new to Salesforce, we’ll help you get started without the stress. If you’ve already got it up and running, we’ll help you take things further. We bring the skills and real-world experience you need to make Salesforce work for you.</p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-london#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-london#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-london#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Support – Backed by Skilled Salesforce Developers in London</h2>
                                <p className="prose-lg">Every industry runs into its own set of headaches, and our Salesforce developers in London get that. Whether you’re in finance, healthcare, retail, logistics, or tech, we build Salesforce solutions that fit how you and your team actually work.</p>
                                <p className="prose-lg">We care about real improvements—automations that save you time, integrations that don’t break, workflows that make sense for your day-to-day. Bottom line? We help you get more out of Salesforce, minus the hassle.</p>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation london" />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions london" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts london" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner london" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting london" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation london" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="CRM solutions london" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why Choose Codezix – Your Salesforce Consulting Partner in London ?</h2>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">100% in-house development ensures quality control.</li>
                                            <li className="wow fadeUp prose-lg">80+ certified Salesforce developers with 300+ credentials.</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business and 90% client retention.</li>
                                            <li className="wow fadeUp prose-lg">Over a decade delivering CRM success worldwide.</li>
                                            <li className="wow fadeUp prose-lg">Over 10 years of industry expertise</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Dedicated maintenance and optimization services.</li>
                                            <li className="wow fadeUp prose-lg">24/7 global Salesforce support across all time zones</li>
                                            <li className="wow fadeUp prose-lg">100% in-house code development for unmatched quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery for smooth execution</li>
                                            <li className="wow fadeUp prose-lg">Thorough testing ensures reliable and high-performance Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='Salesforce experts Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className="service-section-right">
                                            <h3 className="wow fadeUp">3 PL Central</h3>
                                            <p className="wow fadeUp prose-lg">
                                                A <strong>U.S.-based warehouse</strong> management leader, optimized operations using Salesforce automation developed by Codezix.{" "}
                                                <a
                                                    href={central}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>

                                        {/* <div className="services_button_right">
                                                                    <Link to="" ></Link>
                                                                </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Salesforce partner Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club (UK) </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Empowered their fitness community with <strong> data-driven marketing</strong> through Salesforce Marketing Cloud.
                                                <a
                                                    href={club}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='Salesforce experts Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a leading CRM solution, providing a powerful enterprise application compatible across multiple devices. With a robust app marketplace, it strengthens marketing and sales alignment, driving better leads and high-quality pipelines.
                                                <a
                                                    href={campaign}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Salesforce partner Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix (USA)</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Simplified legal case management with Salesforce customization and workflow automation.
                                                <a
                                                    href={advologix}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health (USA)</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Integrated Salesforce Health Cloud for real-time patient engagement.
                                                <a
                                                    href={concert}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Salesforce consulting Dubai' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions (Dubai)</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Enhanced healthcare service delivery using a unified Salesforce Service Cloud system.
                                                <a
                                                    href={solution}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#007bff', textDecoration: 'underline' }}
                                                >
                                                    Learn More
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Insights & Resources</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={london_blog1} alt='Salesforce consulting london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">How Salesforce Automation Supercharges Productivity for London Teams </h3>
                                            <p className="wow fadeUp prose-lg">
                                                If you’re running a business in London, you know how fast things move. Every minute counts, especially when your team is growing. That’s why more and more companies are turning to Salesforce consulting in London — it helps cut out busywork, fix workflow headaches, and gives your team the freedom to focus on what actually matters.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={london_blog2} alt='Salesforce implementation london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce and Data Analytics: Unlocking Insights for London Companies</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce consulting London is helping businesses unlock powerful insights through data analytics. For companies operating in one of the world’s most competitive markets, understanding and using data effectively is essential. By combining Salesforce CRM with advanced analytics, London businesses can turn information into action — improving decision-making, customer experience, and long-term growth.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={london_blog3} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                Salesforce Lightning Migration: London’s Not-So-Secret Weapon
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce Consulting London can turn a messy Lightning migration into a smooth, business-boosting process. Let’s be real: moving to Salesforce Lightning isn’t just flipping a switch—it’s a total game-changer for London companies. With the right consulting team, workflows get faster, analytics make sense, and customers don’t have to wait forever. Having experienced Salesforce consultants in London on your side ensures the switch actually drives results instead of headaches.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* faq section  */}
                            <section className="py-5 bg-light w-100">
  <div className="py-4">

    <div className="accordion w-100" id="faqAccLondon">

      {/* Q1 */}
      <div className="accordion-item border rounded-3 mb-3 shadow-sm">
        <h2 className="accordion-header">
          <button
            className="accordion-button fs-3 fw-semibold collapsed text-start"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faqLon1"
          >
            What Salesforce consulting services does Codezix offer in London?
          </button>
        </h2>
        <div
          id="faqLon1"
          className="accordion-collapse collapse"
          data-bs-parent="#faqAccLondon"
        >
          <div className="accordion-body fs-3 text-muted text-start">
            Codezix handles everything when it comes to Salesforce consulting in London.
            We take care of CRM implementation, customize solutions to fit your business,
            connect Salesforce with your existing systems, manage data migrations,
            and stick around for ongoing support.
          </div>
        </div>
      </div>

      {/* Q2 */}
      <div className="accordion-item border rounded-3 mb-3 shadow-sm">
        <h2 className="accordion-header">
          <button
            className="accordion-button fs-3 fw-semibold collapsed text-start"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faqLon2"
          >
            How can I hire a Salesforce consultant from Codezix in London?
          </button>
        </h2>
        <div
          id="faqLon2"
          className="accordion-collapse collapse"
          data-bs-parent="#faqAccLondon"
        >
          <div className="accordion-body fs-3 text-muted text-start">
            Just reach out through our website or send us an email.
            We’ll talk through what your business needs and then put together
            a Salesforce consulting plan that actually fits your company in London.
          </div>
        </div>
      </div>

      {/* Q3 */}
      <div className="accordion-item border rounded-3 mb-3 shadow-sm">
        <h2 className="accordion-header">
          <button
            className="accordion-button fs-3 fw-semibold collapsed text-start"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faqLon3"
          >
            Does Codezix provide Salesforce cloud solutions in London?
          </button>
        </h2>
        <div
          id="faqLon3"
          className="accordion-collapse collapse"
          data-bs-parent="#faqAccLondon"
        >
          <div className="accordion-body fs-3 text-muted text-start">
            You bet. We work with all the main Salesforce Clouds — Sales Cloud,
            Service Cloud, Marketing Cloud — and we build custom Salesforce apps
            for businesses in London too.
          </div>
        </div>
      </div>

      {/* Q4 */}
      <div className="accordion-item border rounded-3 mb-3 shadow-sm">
        <h2 className="accordion-header">
          <button
            className="accordion-button fs-3 fw-semibold collapsed text-start"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faqLon4"
          >
            How experienced is Codezix in Salesforce projects in London?
          </button>
        </h2>
        <div
          id="faqLon4"
          className="accordion-collapse collapse"
          data-bs-parent="#faqAccLondon"
        >
          <div className="accordion-body fs-3 text-muted text-start">
            Our London team has over 30 certified Salesforce pros.
            We’ve wrapped up more than 50 projects worldwide,
            and plenty of those were right here in London.
          </div>
        </div>
      </div>

      {/* Q5 */}
      <div className="accordion-item border rounded-3 mb-3 shadow-sm">
        <h2 className="accordion-header">
          <button
            className="accordion-button fs-3 fw-semibold collapsed text-start"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faqLon5"
          >
            Can Codezix integrate Salesforce with other business applications in London?
          </button>
        </h2>
        <div
          id="faqLon5"
          className="accordion-collapse collapse"
          data-bs-parent="#faqAccLondon"
        >
          <div className="accordion-body fs-3 text-muted text-start">
            Of course. We connect Salesforce to ERP systems, e-commerce platforms,
            analytics tools, you name it. That way, your operations run smoother
            and everything talks to each other.
          </div>
        </div>
      </div>

      {/* Q6 */}
      <div className="accordion-item border rounded-3 mb-3 shadow-sm">
        <h2 className="accordion-header">
          <button
            className="accordion-button fs-3 fw-semibold collapsed text-start"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faqLon6"
          >
            Does Codezix offer Salesforce automation and AI solutions in London?
          </button>
        </h2>
        <div
          id="faqLon6"
          className="accordion-collapse collapse"
          data-bs-parent="#faqAccLondon"
        >
          <div className="accordion-body fs-3 text-muted text-start">
            Yes, we do. We use Salesforce automation and AI features to help
            London businesses work smarter, engage customers better,
            and make decisions backed by real data.
          </div>
        </div>
      </div>

      {/* Q7 */}
      <div className="accordion-item border rounded-3 mb-3 shadow-sm">
        <h2 className="accordion-header">
          <button
            className="accordion-button fs-3 fw-semibold collapsed text-start"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faqLon7"
          >
            How long does it take to implement Salesforce consulting in London?
          </button>
        </h2>
        <div
          id="faqLon7"
          className="accordion-collapse collapse"
          data-bs-parent="#faqAccLondon"
        >
          <div className="accordion-body fs-3 text-muted text-start">
            It depends on what you need. Simple projects can be up and running
            in a few weeks, but bigger, more complex integrations
            can take a few months.
          </div>
        </div>
      </div>

      {/* Q8 */}
      <div className="accordion-item border rounded-3 shadow-sm">
        <h2 className="accordion-header">
          <button
            className="accordion-button fs-3 fw-semibold collapsed text-start"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faqLon8"
          >
            Why choose Codezix for Salesforce consulting in London?
          </button>
        </h2>
        <div
          id="faqLon8"
          className="accordion-collapse collapse"
          data-bs-parent="#faqAccLondon"
        >
          <div className="accordion-body fs-3 text-muted text-start">
            We know Salesforce inside out, we’ve got a solid track record,
            and we build solutions that actually fit London businesses.
            With us, you get a Salesforce setup that’s scalable, efficient,
            and built for your needs.
          </div>
        </div>
      </div>

    </div>

  </div>
</section>


                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default London;